import { useOpenHours } from 'core/stores'
import { useGetFrontendConfig } from 'core/types'

/**
 * Returns open hours with fallback: companyConfigOverride (from useOpenHours) takes precedence;
 * when the override is undefined, falls back to frontend config openHours.
 * When the override is explicitly null, that clears hours for white-label; config is not substituted.
 */
export const useOpenHoursWithFallback = () => {
  const openHoursFromHook = useOpenHours()
  const { data: config, isLoading: isConfigLoading } = useGetFrontendConfig({})

  const openHours = openHoursFromHook === undefined ? config?.openHours : openHoursFromHook

  // Only report loading when we depend on frontend config. When override is set (value or null), we have our data.
  const isLoading = openHoursFromHook === undefined ? isConfigLoading : false

  return { openHours, isLoading }
}
